import React, { ReactElement } from 'react'
import { BoxProps } from '@mindfulchefuk/design-system/layout/Box'
import { Svg } from '@mindfulchefuk/design-system'

const DinersClub = (props: BoxProps): ReactElement => (
  <Svg viewBox="0 0 26 16" {...props}>
    <rect width="26" height="16" rx="2" ry="2" fill="#2183cb" />
    <path
      d="M13.76 13.06H12A5 5 0 017.22 8a4.86 4.86 0 014.58-5h2a5 5 0 015 5.05v.05a5.08 5.08 0 01-5.04 4.96zm-1.62-9.23a4.18 4.18 0 104.06 4.28V8a4.13 4.13 0 00-4.06-4.17zm.64 7V5.24a2.86 2.86 0 012.05 3.47 2.79 2.79 0 01-2.05 2.1zm-1.28 0a2.88 2.88 0 01-2-3.51 2.82 2.82 0 012-2.06z"
      fill="#fff"
    />
  </Svg>
)

export default DinersClub
